/* --------------------------------------------------------------------------
   Nieuwsbrief-popup

   Wanneer hij verschijnt bepaalt meer over het resultaat dan hoe hij eruitziet.
   Daarom, in volgorde van belang:

   - Nooit bij binnenkomst. Wie nog niets heeft gezien heeft geen reden zich in
     te schrijven, en Google straft opdringerige popups op mobiel af.
   - Nooit op de winkelwagen of tijdens het afrekenen. Een popup daar is een
     verloren bestelling.
   - Eén keer per bezoeker. Wegklikken wordt onthouden; wie zich inschrijft
     ziet hem nooit meer.
   - Na wegklikken blijft het hoekbalkje. Het aanbod verdwijnt niet, het vraagt
     alleen niets meer.

   Zonder JavaScript gebeurt er niets — de popup staat op `hidden` en de
   nieuwsbrief is gewoon in de voettekst te vinden.
   -------------------------------------------------------------------------- */
(function () {
  var popup = document.querySelector('[data-newsletter-popup]');
  if (!popup) return;

  var panel = popup.querySelector('[data-newsletter-panel]');
  var bar = document.querySelector('[data-newsletter-bar]');
  var veld = popup.querySelector('[data-newsletter-email]');
  var laatstActief = null;
  var getoond = false;

  var SLEUTEL = {
    weg: 'elpasha:nieuwsbrief-weggeklikt',
    aan: 'elpasha:nieuwsbrief-ingeschreven',
    tel: 'elpasha:paginateller',
  };

  /* Een browser in privémodus kan bij opslag een fout gooien. Dan werkt de
     popup gewoon, hij onthoudt alleen niets. */
  var lees = function (sleutel) {
    try {
      return window.localStorage.getItem(sleutel);
    } catch (e) {
      return null;
    }
  };

  var schrijf = function (sleutel, waarde) {
    try {
      window.localStorage.setItem(sleutel, waarde);
    } catch (e) {
      /* niets */
    }
  };

  var dagen = parseInt(popup.dataset.rememberDays, 10) || 30;
  var nodigePaginas = parseInt(popup.dataset.pageviews, 10) || 2;
  var wachttijd = (parseInt(popup.dataset.delay, 10) || 20) * 1000;
  var trigger = popup.dataset.trigger || 'vertrek';

  var ingeschreven = function () {
    return lees(SLEUTEL.aan) === 'ja';
  };

  var weggeklikt = function () {
    var stempel = parseInt(lees(SLEUTEL.weg), 10);
    if (!stempel) return false;
    return Date.now() - stempel < dagen * 24 * 60 * 60 * 1000;
  };

  /* Op de winkelwagen en in de checkout blijft hij weg. */
  var verbodenPagina = function () {
    var pad = window.location.pathname;
    return pad.indexOf('/cart') === 0
      || pad.indexOf('/checkouts') === 0
      || pad.indexOf('/checkout') === 0;
  };

  /* ------------------------------------------------------------------
     Openen en sluiten
     ------------------------------------------------------------------ */

  var focusbaar = function () {
    return panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea'
    );
  };

  var toonBalkje = function () {
    if (!bar) return;
    if (popup.dataset.showBar !== 'ja') return;
    if (ingeschreven()) return;
    if (lees(SLEUTEL.weg + ':balkje') === 'weg') return;
    bar.hidden = false;
  };

  var open = function () {
    if (popup.hidden === false) return;

    laatstActief = document.activeElement;
    popup.hidden = false;
    getoond = true;

    window.requestAnimationFrame(function () {
      popup.classList.add('is-open');
      if (veld) veld.focus();
    });

    document.documentElement.style.overflow = 'hidden';
    if (bar) bar.hidden = true;
  };

  var sluit = function (onthouden) {
    if (popup.hidden) return;

    popup.classList.remove('is-open');
    document.documentElement.style.overflow = '';

    window.setTimeout(function () {
      popup.hidden = true;
    }, 240);

    if (onthouden) schrijf(SLEUTEL.weg, String(Date.now()));
    if (laatstActief && laatstActief.focus) laatstActief.focus();

    toonBalkje();
  };

  /* ------------------------------------------------------------------
     Bediening
     ------------------------------------------------------------------ */

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-newsletter-close]')) {
      event.preventDefault();
      sluit(true);
      return;
    }

    if (event.target.closest('[data-newsletter-open]')) {
      event.preventDefault();
      open();
      return;
    }

    if (event.target.closest('[data-newsletter-bar-close]')) {
      event.preventDefault();
      if (bar) bar.hidden = true;
      schrijf(SLEUTEL.weg + ':balkje', 'weg');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (popup.hidden) return;

    if (event.key === 'Escape') {
      sluit(true);
      return;
    }

    if (event.key !== 'Tab') return;

    var items = focusbaar();
    if (!items.length) return;

    var eerste = items[0];
    var laatste = items[items.length - 1];

    if (event.shiftKey && document.activeElement === eerste) {
      event.preventDefault();
      laatste.focus();
    } else if (!event.shiftKey && document.activeElement === laatste) {
      event.preventDefault();
      eerste.focus();
    }
  });

  /* ------------------------------------------------------------------
     Wanneer hij zichzelf toont
     ------------------------------------------------------------------ */

  /* Net ingeschreven: Shopify laadt de pagina opnieuw met de bevestiging
     erin. Die tonen wij meteen, ongeacht de trigger. */
  var netIngeschreven = window.location.search.indexOf('customer_posted=true') !== -1;

  if (netIngeschreven) {
    schrijf(SLEUTEL.aan, 'ja');
    if (bar) bar.hidden = true;
    open();
    return;
  }

  if (ingeschreven()) return;

  if (weggeklikt()) {
    toonBalkje();
    return;
  }

  if (verbodenPagina()) return;

  var teller = (parseInt(lees(SLEUTEL.tel), 10) || 0) + 1;
  schrijf(SLEUTEL.tel, String(teller));

  var genoegGezien = teller >= nodigePaginas;
  var smal = window.matchMedia('(max-width: 767px)').matches;

  if (trigger === 'tijd') {
    window.setTimeout(function () {
      if (!getoond) open();
    }, wachttijd);
    return;
  }

  if (trigger === 'paginas' || smal) {
    /* Vertrekintentie bestaat op een telefoon niet betrouwbaar, dus daar
       telt het aantal pagina's. */
    if (genoegGezien) {
      window.setTimeout(function () {
        if (!getoond) open();
      }, 1200);
    }
    return;
  }

  /* Desktop, vertrekintentie: de muis verlaat het venster aan de bovenkant. */
  var bijVertrek = function (event) {
    if (event.clientY > 0) return;
    document.removeEventListener('mouseout', bijVertrek);
    if (!getoond) open();
  };

  document.addEventListener('mouseout', bijVertrek);
})();
